import { Submission } from '../../types';
import { apiError } from '../../utils/errors';
import { getApiBaseUrl } from '../../utils/api-base-url';

export const resendToken = async (
  urlSlug: string,
  publicId: string,
): Promise<Submission> => {
  const response = await fetch(`${getApiBaseUrl()}/submissions/${urlSlug}/${publicId}/tokens/resend`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  const responseJson = await response.json();
  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch application');
  }

  return responseJson;
};
